module.exports = __webpack_public_path__ + "static/vscode-b01a7ddff64a3580d6e5db476e568070.png";